import { Icon, TextField } from '@material-ui/core'
import React, { useEffect, useRef, useState } from 'react'

export default function BusquedaDirecta({ onAddGuia }) {
  const [Value, setValue] = useState('');
  const InputRef = useRef(null);

  useEffect(() => {
    document.addEventListener("keydown", onKeyPressed, false);

    return () => {
      document.removeEventListener('keydown', onKeyPressed);
    }
  }, []);

  const onSearch = () => {
    onAddGuia(Value);
  }

  const onKeyPressed = (e) => {
    // console.log(e.key);
    if (e.key === 'F2') {
      // console.log('FOCUS')
      InputRef.current.focus();
      e.preventDefault();
    }
  }

  const onInputKeyPressed = (e) => {
    if (e.key === 'Enter') {
      console.log('hola')
      onAddGuia(Value);
    }
  }

  return (
    <div style={{ paddingBottom: 15 }}>
      <h5>Búsqueda directa</h5>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TextField inputRef={InputRef} size='small' variant='outlined' value={Value} onChange={e => setValue(e.target.value)} onKeyPress={onInputKeyPressed} />
        <Icon onClick={onSearch}>search</Icon>
      </div>
    </div>
  )
}
